import React, { useEffect, useState } from 'react';
import { ArrowLeft, FolderIcon } from 'lucide-react';

import {
  GeneralDocument,
  GeneralDocumentFolder,
  useGeneralDocumentStore,
} from '../../../stores/generalDocumentsStore';
//import { CropConnectBreadcrumb } from '../CropConnectBreadcrumb/CropConnectBreadcrumb';
import {
  CenteredH2,
  GeneralDocumentPickerItem,
  Header,
  IconWrapper,
  ModalActionContainer,
  ModalContent,
  ModalOverlay,
  ScrollableContent,
} from './styles';
import PDFIcon from '../../../assets/icons/PDFIcon';
import ActionButton from '../ActionButton/ActionButton';
import { useI18n } from '../../../hooks/useI18n';
import { TranslationKeys } from '../../../i18n/locales/defaultResources';
import WordIcon from '../../../assets/icons/WordIcon';
import ExcelIcon from '../../../assets/icons/ExcelIcon';

interface GeneralDocumentPickerProps {
  onGeneralDocumentPicked?: (
    generalDocumentEcmId: number,
    parentFolder: number,
    generalDocumentEcmName?: string
  ) => void;
}

const GeneralDocumentPicker: React.FC<GeneralDocumentPickerProps> = ({
  onGeneralDocumentPicked,
}) => {
  const { t } = useI18n();

  const { getGeneralDocumentsFolder } = useGeneralDocumentStore();
  const [currentFolder, setCurrentFolder] = useState<
    GeneralDocumentFolder | undefined
  >();
  const [previousFoldersIds, setPreviousFoldersIds] = useState<
    (number | undefined)[]
  >([]);
  // const [breadCrumbFolders, setBreadcrumbFolders] = useState<
  //   GeneralDocumentFolder[]
  // >([]);
  const [isLoading, setIsLoading] = useState<boolean>();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  useState<string | undefined>();

  const loadFolder = (folderId?: number | undefined) => {
    setIsLoading(true);
    getGeneralDocumentsFolder(folderId)
      .then((f) => {
        setCurrentFolder(f);
        //setBreadcrumbFolders(calculateBreadcrumbFolders(f, f.id));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    loadFolder(currentFolder?.id);
  }, []);

  const onFolderClicked = (folderId: number) => {
    setPreviousFoldersIds([...previousFoldersIds, currentFolder?.id]);
    loadFolder(folderId);
  };

  const onBackClicked = () => {
    loadFolder(previousFoldersIds.pop());
    setPreviousFoldersIds(previousFoldersIds);
  };

  // const removeDuplicateFolders = (
  //   folders: GeneralDocumentFolder[]
  // ): GeneralDocumentFolder[] => {
  //   const uniqueFolders = new Map<number, GeneralDocumentFolder>();

  //   folders.forEach((folder) => {
  //     if (!uniqueFolders.has(folder.id)) {
  //       uniqueFolders.set(folder.id, {
  //         ...folder,
  //         subfolders: folder.subfolders
  //           ? removeDuplicateFolders(folder.subfolders)
  //           : [],
  //       });
  //     }
  //   });

  //   return Array.from(uniqueFolders.values());
  // };

  // const calculateBreadcrumbFolders = (
  //   currentFolder: GeneralDocumentFolder,
  //   currentFolderId?: number | undefined
  // ) => {
  //   const newBreadcrumbFolders: GeneralDocumentFolder[] = [];
  //   for (let i = 0; i < breadCrumbFolders.length; i++) {
  //     const currentProcessedFolder = breadCrumbFolders[i];
  //     if (currentProcessedFolder.id == currentFolderId) {
  //       //We arrived at our clicked folder skip the rest
  //       break;
  //     } else {
  //       newBreadcrumbFolders.push(currentProcessedFolder);
  //     }
  //   }
  //   newBreadcrumbFolders.push(currentFolder);

  //   const uniqueFolders = new Map<number, GeneralDocumentFolder>();
  //   //Need to remove duplicates
  //   newBreadcrumbFolders.forEach((folder) => {
  //     if (!uniqueFolders.has(folder.id)) {
  //       uniqueFolders.set(folder.id, {
  //         ...folder,
  //         subfolders: folder.subfolders
  //           ? removeDuplicateFolders(folder.subfolders)
  //           : [],
  //       });
  //     }
  //   });

  //   return Array.from(uniqueFolders.values());
  // };

  const renderBackOptionIfNeccessary = () => {
    if (previousFoldersIds.length > 0) {
      return (
        <GeneralDocumentPickerItem key="back" onClick={onBackClicked}>
          <IconWrapper>
            <ArrowLeft />
          </IconWrapper>
          {t(TranslationKeys.generaldocuments_picker_back_option)}
        </GeneralDocumentPickerItem>
      );
    }
  };

  const renderFolderItems = (folders: GeneralDocumentFolder[] | undefined) => {
    return folders?.map((f) => (
      <GeneralDocumentPickerItem
        key={f.id}
        onClick={onFolderClicked.bind(this, f.id)}
      >
        <IconWrapper>
          <FolderIcon fill="#fbc843" />
        </IconWrapper>
        {f.name}
      </GeneralDocumentPickerItem>
    ));
  };

  const renderFileItems = (files: GeneralDocument[] | undefined) => {
    console.log(files);
    return files?.map((f) => (
      <GeneralDocumentPickerItem
        key={f.id}
        onClick={() => {
          setIsModalOpen(false);
          onGeneralDocumentPicked &&
            onGeneralDocumentPicked(f.id, currentFolder!.id!, f.name);
        }}
      >
        <IconWrapper>
          {f.name.endsWith('.doc') || f.name.endsWith('.docx') ? (
            <WordIcon />
          ) : f.name.endsWith('.xls') || f.name.endsWith('.xlsx') ? (
            <ExcelIcon />
          ) : (
            <PDFIcon color="#323F4B" />
          )}
        </IconWrapper>
        {f.name}
      </GeneralDocumentPickerItem>
    ));
  };

  return (
    <>
      <button onClick={() => setIsModalOpen(true)}>
        {t(TranslationKeys.generaldocuments_picker_open_picker_button)}
      </button>
      {isModalOpen && (
        <ModalOverlay>
          <ModalContent>
            <Header>
              <CenteredH2>
                {t(TranslationKeys.generaldocuments_picker_header)}
              </CenteredH2>
            </Header>
            {isLoading ? (
              <div>
                {t(TranslationKeys.generaldocuments_picker_loading_info)}
              </div>
            ) : (
              <>
                {/* <CropConnectBreadcrumb
                  items={breadCrumbFolders.map((f) => {
                    return { id: f.id, name: f.name };
                  })}
                  onItemClicked={(clickedItem) => {
                    loadFolder(clickedItem.id);
                  }}
                /> */}
                <ScrollableContent>
                  <ul>
                    {renderBackOptionIfNeccessary()}
                    {renderFolderItems(currentFolder?.subfolders)}
                    {renderFileItems(currentFolder?.documents)}
                  </ul>
                </ScrollableContent>
                <ModalActionContainer>
                  <ActionButton
                    variant="accept-blue"
                    buttonText="Close"
                    onClickAction={() => setIsModalOpen(false)}
                  />
                </ModalActionContainer>
              </>
            )}
          </ModalContent>
        </ModalOverlay>
      )}
    </>
  );
};

export default GeneralDocumentPicker;
